<template>
  <div class="stbox">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>感染监测数据分析</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- style="display: flex" -->
    <div>
      <div style="margin-left:10px;margin-top:10px">
        <el-select clearable filterable v-model="searchArea" v-show="hShow" @change="areaChange" placeholder="请选择区域">
          <el-option v-for="item in areaData" :key="item.id" :label="item.label" :value="item.id">
          </el-option>
        </el-select>
        <el-select clearable filterable v-show="hShow" v-model="searchHospitalNumber" @change="hospitalChange"
          placeholder="请选择医院">
          <el-option v-for="item in hospitalData" :key="item.HospitalNumber" :label="item.HospitalName"
            :value="item.HospitalNumber">
          </el-option>
        </el-select>
        <el-date-picker v-model="tjny" type="monthrange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始月份" end-placeholder="结束月份" format="yyyy-MM" value-format="yyyy-MM"
          :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="searchData">查询</el-button>
        <el-button v-show="!hShow" type="primary" icon="el-icon-download" @click="exportData">导出</el-button>
        <el-button v-show="hShow" type="primary" icon="el-icon-download" @click="exportAllData">导出</el-button>
      </div>
      <div style="margin-left:10px;margin-top:10px">
        <el-table v-show="!isAllHsopital" v-loading="newload" element-loading-text="加载中" height="750"
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="tableData"
          style="width: 100%" class="indicators">
          <el-table-column align="center" label="感染监测数据分析结果">
            <el-table-column prop="zb" label="指标" width="100"> </el-table-column>
            <el-table-column prop="nr" label="内容" width="250"> </el-table-column>
            <el-table-column prop="fz" label="分子" width="250"> </el-table-column>
            <el-table-column prop="fzsz" label="分子数值" width="180"></el-table-column>
            <el-table-column prop="fm" label="分母" width="250"> </el-table-column>
            <el-table-column prop="fmsz" label="分母数值" width="180"></el-table-column>
            <el-table-column prop="sj" label="结果数据" width="180"></el-table-column>
            <el-table-column prop="bz" label="备注"> </el-table-column>
          </el-table-column>
        </el-table>
        <el-table v-show="isAllHsopital" v-loading="newload" element-loading-text="加载中" height="750"
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="tableData2"
          style="width: 100%" class="table">
          <el-table-column fixed="left" prop="dataType" label="备注" width="110"> </el-table-column>
          <el-table-column fixed="left" prop="name" label="市" width="80"> </el-table-column>
          <el-table-column fixed="left" prop="HospitalLevel" label="级别" width="80"> </el-table-column>
          <el-table-column fixed="left" prop="hospitalProperty" label="类型" width="80"> </el-table-column>
          <el-table-column fixed="left" prop="HospitalName" label="医院名称" width="220"> </el-table-column>
          <el-table-column fixed="left" prop="tjny" label="统计月份"> </el-table-column>
          <el-table-column label="指标一">
            <el-table-column prop="fz1" label="实际开放床位数" />
            <el-table-column prop="fm1" label="同期感控专职人员数" />
            <el-table-column prop="sj1" label="感控专职人员床位比" />
          </el-table-column>
          <el-table-column label="指标二">
            <el-table-column prop="fz2" label="医疗机构工作人员实际执行手卫生时机数" />
            <el-table-column prop="fm2" label="同期应执行手卫生时机数" />
            <el-table-column prop="sj2" label="医疗机构工作人员手卫生依从率(%)" />
            <el-table-column prop="fz2_1" label="医疗机构医生人员实际执行手卫生时机数" />
            <el-table-column prop="fm2_1" label="同期医生人员应执行手卫生时机数" />
            <el-table-column prop="sj2_1" label="医疗机构医生人员手卫生依从率(%)" />
            <el-table-column prop="fz2_2" label="医疗机构护士人员实际执行手卫生时机数" />
            <el-table-column prop="fm2_2" label="同期护士人员应执行手卫生时机数" />
            <el-table-column prop="sj2_2" label="医疗机构护士人员手卫生依从率(%)" />
            <el-table-column prop="fz2_3" label="医疗机构其他人员实际执行手卫生时机数" />
            <el-table-column prop="fm2_3" label="同期其他人员应执行手卫生时机数" />
            <el-table-column prop="sj2_3" label="医疗机构其他人员手卫生依从率(%)" />
          </el-table-column>
          <el-table-column label="指标三">
            <el-table-column prop="fz3" label="医院感染新发病例例次数" />
            <el-table-column prop="fm3" label="同期住院患者累计住院天数" />
            <el-table-column prop="sj3" label="千日医院感染例次发病率(例/千住院日)(‰)" />
          </el-table-column>
          <el-table-column label="指标四">
            <el-table-column prop="fz4" label="新生儿医院感染新发病例例次数" />
            <el-table-column prop="fm4" label="同期新生儿住院患者累计住院天数" />
            <el-table-column prop="sj4" label="新生儿千日医院感染例次发病率(例/千住院日)(‰)" />
          </el-table-column>
          <el-table-column label="指标五">
            <el-table-column prop="fz5" label="特定多重耐药菌医院感染新发病例例次数" />
            <el-table-column prop="fm5" label="同期住院患者累计住院天数" />
            <el-table-column prop="sj5" label="千日特定多重耐药菌医院感染例次发病率(例/千住院日)(‰)" />
            <el-table-column prop="fz5_1" label="耐甲氧西林金黄色葡萄球菌(MRSA)医院感染新发病例例次数" />
            <el-table-column prop="fm5_1" label="同期住院患者累计住院天数" />
            <el-table-column prop="sj5_1" label="耐甲氧西林金黄色葡萄球菌(MRSA)(例/千住院日)(‰)" />
            <el-table-column prop="fz5_2" label="耐万古霉素肠球菌(VRE,仅指屎肠球菌、粪肠球菌)医院感染新发病例例次数" />
            <el-table-column prop="fm5_2" label="同期住院患者累计住院天数" />
            <el-table-column prop="sj5_2" label="耐万古霉素肠球菌(VRE,仅指屎肠球菌、粪肠球菌)(例/千住院日)(‰)" />
            <el-table-column prop="fz5_4" label="耐碳青霉烯类肺炎克雷伯菌(CRKP)医院感染新发病例例次数" />
            <el-table-column prop="fm5_4" label="同期住院患者累计住院天数" />
            <el-table-column prop="sj5_4" label="耐碳青霉烯类肺炎克雷伯菌(CRKP)(例/千住院日)(‰)" />
            <el-table-column prop="fz5_5" label="耐碳青霉烯类大肠埃希菌(CREC)医院感染新发病例例次数" />
            <el-table-column prop="fm5_5" label="同期住院患者累计住院天数" />
            <el-table-column prop="sj5_5" label="耐碳青霉烯类大肠埃希菌(CREC)(例/千住院日)(‰)" />
            <el-table-column prop="fz5_6" label="耐碳青霉烯类铜绿假单胞菌(CRPA)医院感染新发病例例次数" />
            <el-table-column prop="fm5_6" label="同期住院患者累计住院天数" />
            <el-table-column prop="sj5_6" label="耐碳青霉烯类铜绿假单胞菌(CRPA)(例/千住院日)(‰)" />
            <el-table-column prop="fz5_7" label="耐碳青霉烯类鲍曼不动杆菌(CRAB)医院感染新发病例例次数" />
            <el-table-column prop="fm5_7" label="同期住院患者累计住院天数" />
            <el-table-column prop="sj5_7" label="耐碳青霉烯类鲍曼不动杆菌(CRAB)(例/千住院日)(‰)" />
          </el-table-column>
          <el-table-column label="指标六">
            <el-table-column prop="fz6" label="联合使用重点抗菌药物治疗前病原学送检的住院患者人数" />
            <el-table-column prop="fm6" label="同期联合使用重点抗菌药物治疗的住院患者总人数" />
            <el-table-column prop="sj6" label="住院患者联合使用重点抗菌药物治疗前病原学送检率(%)" />
          </el-table-column>
          <el-table-column label="指标七">
            <el-table-column prop="fz7" label="住院患者中预防性使用抗菌药物的Ⅰ类切口手术例次数" />
            <el-table-column prop="fm7" label="同期住院患者Ⅰ类切口手术总例次数" />
            <el-table-column prop="sj7" label="住院患者I类切口手术抗菌药物预防使用率(%)" />
          </el-table-column>
          <el-table-column label="指标八">
            <el-table-column prop="fz8" label="住院患者Ⅰ类切口手术发生手术部位感染的例次数" />
            <el-table-column prop="fm8" label="同期住院患者Ⅰ类切口手术总例次数" />
            <el-table-column prop="sj8" label="住院患者I类切口手术部位感染率(%)" />
            <el-table-column prop="fz8_1" label="同期I类切口手术(脑出血)发生手术部位感染的例次数" />
            <el-table-column prop="fm8_1" label="同期I类切口手术(脑出血)例次数" />
            <el-table-column prop="sj8_1" label="I类切口手术部位(脑出血)感染率(%)" />
            <el-table-column prop="fz8_2" label="同期I类切口手术(髋关节置换)发生手术部位感染的例次数" />
            <el-table-column prop="fm8_2" label="同期I类切口手术(髋关节置换)例次数" />
            <el-table-column prop="sj8_2" label="I类切口手术部位(髋关节置换)感染率(%)" />
            <el-table-column prop="fz8_3" label="同期I类切口手术(膝关节置换)发生手术部位感染的例次数" />
            <el-table-column prop="fm8_3" label="同期I类切口手术(膝关节置换)例次数" />
            <el-table-column prop="sj8_3" label="I类切口手术部位(膝关节置换)感染率(%)" />
          </el-table-column>
          <el-table-column label="指标九">
            <el-table-column prop="fz9" label="相关血流感染新发病例例次数" />
            <el-table-column prop="fm9" label="同期住院患者血管导管累计使用天数" />
            <el-table-column prop="sj9" label="血管导管相关血流感染发病率(例/千导管日)(%)" />
          </el-table-column>
          <el-table-column label="指标十">
            <el-table-column prop="fz10" label="相关肺炎新发病例例次数" />
            <el-table-column prop="fm10" label="同期住院患者有创呼吸机累计使用天数" />
            <el-table-column prop="sj10" label="呼吸机相关肺炎发病率(例/千导管日)(%)" />
          </el-table-column>
          <el-table-column label="指标十一">
            <el-table-column prop="fz11" label="相关尿路感染新发病例例次数" />
            <el-table-column prop="fm11" label="同期住院患者导尿管累计使用天数" />
            <el-table-column prop="sj11" label="导尿管相关尿路感染发病率(例/千导管日)(%)" />
          </el-table-column>
          <el-table-column label="指标十二">
            <el-table-column prop="fz12" label="血液透析患者新发生相关感染的例次数" />
            <el-table-column prop="fm12" label="同期血液透析总人数" />
            <el-table-column prop="sj12" label="血液透折相关感染发生率(%)" />
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="search">
        <el-form ref="form" :model="searchForm" label-width="80px" size="small">
          <el-form-item label="范围选择" v-show="hShow">
            <el-select style="width: 75%" clearable filterable size="small" v-model="searchArea">
              <el-option v-for="item in areaData" :key="item.id" :label="item.label" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医院名称" v-show="hShow">
            <el-select clearable filterable size="small" style="width: 75%" v-model="searchHospitalNumber"
              placeholder="请选择医院">
              <el-option v-for="item in hospitalData" :key="item.HospitalNumber" :label="item.HospitalName"
                :value="item.HospitalNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计类型">
            <el-select v-model="searchForm.tjlx" style="width: 75%">
              <el-option label="本期统计" value="本期统计"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快捷选择" v-if="searchForm.tjlx == '本期统计'">
            <el-button type="text" v-for="(item, index) in tjlxArr" :key="index" @click="tjlxClick(item)">{{ item
              }}</el-button>
          </el-form-item>
          <el-form-item label="快捷选择" v-else>
            <el-button type="text" v-for="(item, index) in tjlxArrPast" :key="index" @click="tjlxClick(item)">{{ item
              }}</el-button>
          </el-form-item>
          <el-form-item label="统计时间">
            <el-date-picker v-model="searchForm.tjsj" type="monthrange" @change="handleChange" align="right"
              style="width: 75%" unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
              :picker-options="pickerOptions" value-format="yyyy-MM">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
        <label>{{ loginUser.HospitalName }}({{ searchForm.tjsj[0] }}-{{
          searchForm.tjsj[0]
        }})</label>
        <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)" :data="tjData" @row-click="zbmcClick">
          <el-table-column prop="id" width="50"> </el-table-column>
          <el-table-column prop="zbmc" label="指标名称" width="270"> </el-table-column>
          <el-table-column label="比例">
            <template slot-scope="scope">
              <label v-if="scope.row.id != 1">{{ scope.row.zhi }}</label>
              <label v-else>{{ scope.row.zhi }}</label>
            </template>
</el-table-column>
<el-table-column prop="lcs" label="例次数"> </el-table-column>
</el-table>
</div>
<div>
  <div ref="lineChart" style="width: 1100px; height: 280px"></div>
  <el-table v-loading="loading2" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" :data="tjChildData">
    <el-table-column prop="m" label="日期"> </el-table-column>
    <el-table-column label="类型">
      <template slot-scope="scope">
              <label v-if="scope.row.type == 'MRSA'">耐甲氧西林金黄色葡萄球菌</label>
              <label v-else-if="scope.row.type == 'VRE'">耐万古霉素肠球菌（仅指屎肠球菌、粪肠球菌）</label>
              <label v-else-if="scope.row.type == 'CRKP'">耐碳青霉烯类肺炎克雷伯菌</label>
              <label v-else-if="scope.row.type == 'CREC'">耐碳青霉烯类大肠埃希菌</label>
              <label v-else-if="scope.row.type == 'CRPA'">耐碳青霉烯类铜绿假单胞菌</label>
              <label v-else-if="scope.row.type == 'CRAB'">耐碳青霉烯类鲍曼不动杆菌</label>
              <label v-else-if="scope.row.type == 'ZXJMZG'">中心静脉置管</label>
              <label v-else-if="scope.row.type == 'MNDCG'">泌尿道插管</label>
              <label v-else-if="scope.row.type == 'HXJ'">呼吸机</label>
              <label v-else-if="scope.row.type == 'XTZXJMZG'">血透中心静脉置管</label>
              <label v-else-if="scope.row.type == 'CVC'">中心静脉导管</label>
              <label v-else-if="scope.row.type == 'PICC'">经外周置入中心静脉导管</label>
              <label v-else-if="scope.row.type == 'PORT'">输液港</label>
              <label v-else-if="scope.row.type == 'UVC'">脐静脉导管</label>
              <label v-else>{{ scope.row.type || '' }}</label>
            </template></el-table-column>
    <el-table-column label="总数">
      <template slot-scope="scope">
              {{ scope.row.a1 || 0 }}
            </template></el-table-column>
    <el-table-column label="发生数">
      <template slot-scope="scope">
              {{ scope.row.b1 || 0 }}
            </template></el-table-column>
    <el-table-column label="比例">
      <template slot-scope="scope">
              {{ scope.row.c1 || 0 }}
            </template>
    </el-table-column>
  </el-table>
</div> -->
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import * as XLSX from "xlsx";
import * as echarts from "echarts";
import { getHospital, getAllArea } from "../../api/hospital";
import {
  getStatisticalAnalysis,
  getInfectionIncidence,
  getInfectionDetection,
  getAntibioticsInpatients,
  getInfectionRate,
  getIncidenceIntravascular,
  getIncidenceUrinary,
  getIncidenceVentilator,
  getInfectionIncidence2,
  getInfectionDetection2,
  getAntibioticsInpatients2,
  getInfectionRate2,
  getIncidenceIntravascular2,
  getIncidenceUrinary2,
  getIncidenceVentilator2,
  getIncidenceRate,
  getIncidenceRate2,
  getCaseIncidence,
  getCaseIncidence2,
  getDetectionRate,
  getDetectionRate2,
  getDrawingRate,
  getDrawingRate2,
  getDeliveryRate,
  getDeliveryRate2,
  getUtilizationRate,
  getUtilizationRate2,
  computeTwelveIndicators1,
  computeTwelveIndicators2,
  computeTwelveIndicators3,
  //新
  getCalculationIndexResults
} from "../../api/search";
export default {
  name: "LineChart",
  data() {
    return {
      hospitalNumber: "",
      searchForm: {
        tjlx: "本期统计",
        tjsj: [this.getCurrentDateYYYYMM(), this.getCurrentDateYYYYMM()],
        // sjly: "全部",
      },
      tjlxArr: ["本月", "本季", "上半年", "下半年", "本年"], //本期
      tjlxArrPast: ["按月", "按季", "按半年", "按年"], //往期
      searchParams: {
        yydm: "",
        kssj: "",
        jssj: "",
        area: "",
      },
      tjData: [
        { id: 1, zbmc: "感控专职人员床位比", zhi: "0", lcs: "0" },
        { id: 2, zbmc: "医疗机构工作人员手卫生依从率", zhi: "0", lcs: "0" },
        { id: 3, zbmc: "千日医院感染例次发病率", zhi: "0", lcs: "0" },
        { id: 4, zbmc: "新生儿千日医院感染例次发病率", zhi: "0", lcs: "0" },
        {
          id: 5,
          zbmc: "千日特定多重耐药菌医院感染例次发病率",
          zhi: "0",
          lcs: "0",
        },
        {
          id: 6,
          zbmc: "住院患者联合使用重点抗菌药物治疗前病原学送检率",
          zhi: "0",
          lcs: "0",
        },
        {
          id: 7,
          zbmc: "住院患者I类切口手术抗菌药物预防使用率",
          zhi: "0",
          lcs: "0",
        },
        { id: 8, zbmc: "住院患者I类切口手术部位感染率", zhi: "0", lcs: "0" },
        { id: 9, zbmc: "中心静脉导管相关血流感染发病率", zhi: "0", lcs: "0" },
        { id: 10, zbmc: "呼吸机相关肺炎发病率", zhi: "0", lcs: "0" },
        { id: 11, zbmc: "导尿管相关尿路感染发病率", zhi: "0", lcs: "0" },
        { id: 12, zbmc: "血液透折相关感染发生率", zhi: "0", lcs: "0" },
      ],
      tjChildData: [],
      lineData: [],
      loginUser: {},
      xAxisData: [],
      clickName: "",
      hospitalData: [],
      searchHospitalNumber: "",
      searchHospitalName: "",
      hShow: false,
      areaData: [],
      searchArea: "",
      loading: true,
      loading2: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      //新
      tjny: '',
      newload: false,
      isAllHsopital: false,
      tableData: [
        {
          zb: "指标一",
          nr: "感控专职人员床位比",
          fz: "实际开放床位数",
          fzsz: "",
          fm: "同期感控专职人员数",
          fmsz: "",
          sj: "",
          bz: "",
        },
        {
          zb: "指标二",
          nr: "医疗机构工作人员手卫生依从率",
          fz: "医疗机构工作人员实际执行手卫生时机数",
          fzsz: "",
          fm: "同期应执行手卫生时机数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "2.1",
          nr: "医生",
          fz: "医疗机构医生人员实际执行手卫生时机数",
          fzsz: "",
          fm: "同期医生人员应执行手卫生时机数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "2.2",
          nr: "护士",
          fz: "医疗机构护士人员实际执行手卫生时机数",
          fzsz: "",
          fm: "同期护士人员应执行手卫生时机数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "2.3",
          nr: "其他人员",
          fz: "医疗机构其他人员实际执行手卫生时机数",
          fzsz: "",
          fm: "同期其他人员应执行手卫生时机数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "指标三",
          nr: "千日医院感染例次发病率(例/千住院日)",
          fz: "医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标四",
          nr: "新生儿千日医院感染例次发病率(例/千住院日)",
          fz: "新生儿医院感染新发病例例次数",
          fzsz: "",
          fm: "同期新生儿住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标五",
          nr: "千日特定多重耐药菌医院感染例次发病率(例/千住院日)",
          fz: "特定多重耐药菌医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.1",
          nr: "耐甲氧西林金黄色葡萄球菌(MRSA)(例/千住院日)",
          fz: "耐甲氧西林金黄色葡萄球菌(MRSA)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.2",
          nr: "耐万古霉素肠球菌(VRE,仅指屎肠球菌、粪肠球菌)((例/千住院日)",
          fz: "耐万古霉素肠球菌(VRE,仅指屎肠球菌、粪肠球菌)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.3",
          nr: "耐碳青霉烯类肺炎克雷伯菌(CRKP)(例/千住院日)",
          fz: "耐碳青霉烯类肺炎克雷伯菌(CRKP)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.4",
          nr: "耐碳青霉烯类大肠埃希菌(CREC)(例/千住院日)",
          fz: "耐碳青霉烯类大肠埃希菌(CREC)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.5",
          nr: "耐碳青霉烯类铜绿假单胞菌(CRPA)(例/千住院日)",
          fz: "耐碳青霉烯类铜绿假单胞菌(CRPA)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "5.6",
          nr: "耐碳青霉烯类鲍曼不动杆菌(CRAB)(例/千住院日)",
          fz: "耐碳青霉烯类鲍曼不动杆菌(CRAB)医院感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者累计住院天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标六",
          nr: "住院患者联合使用重点抗菌药物治疗前病原学送检率",
          fz: "联合使用重点抗菌药物治疗前病原学送检的住院患者人数",
          fzsz: "",
          fm: "同期联合使用重点抗菌药物治疗的住院患者总人数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "指标七",
          nr: "住院患者I类切口手术抗菌药物预防使用率",
          fz: "住院患者中预防性使用抗菌药物的Ⅰ类切口手术例次数",
          fzsz: "",
          fm: "同期住院患者Ⅰ类切口手术总例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "指标八",
          nr: "住院患者I类切口手术部位感染率",
          fz: "住院患者Ⅰ类切口手术发生手术部位感染的例次数",
          fzsz: "",
          fm: "同期住院患者Ⅰ类切口手术总例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "8.1",
          nr: "I类切口手术部位(脑出血)感染率",
          fz: "同期I类切口手术(脑出血)发生手术部位感染的例次数",
          fzsz: "",
          fm: "同期I类切口手术(脑出血)例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "8.2",
          nr: "I类切口手术部位(髋关节置换)感染率",
          fz: "同期I类切口手术(髋关节置换)发生手术部位感染的例次数",
          fzsz: "",
          fm: "同期I类切口手术(髋关节置换)例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "8.3",
          nr: "I类切口手术部位(膝关节置换)感染率",
          fz: "同期I类切口手术(膝关节置换)发生手术部位感染的例次数",
          fzsz: "",
          fm: "同期I类切口手术(膝关节置换)例次数",
          fmsz: "",
          sj: "",
          bz: "%",
        },
        {
          zb: "指标九",
          nr: "血管导管相关血流感染发病率(例/千导管日)",
          fz: "相关血流感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者血管导管累计使用天数",
          fmsz: "",
          sj: "",
          bz: "‰,血管导管包括中心静脉导管(CVC)、经外周置入中心静脉导管(PICC)、输液港(PORT)、脐静脉导管",
        },
        {
          zb: "指标十",
          nr: "呼吸机相关肺炎发病率(例/千导管日)",
          fz: "相关肺炎新发病例例次数",
          fzsz: "",
          fm: "同期住院患者有创呼吸机累计使用天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标十一",
          nr: "导尿管相关尿路感染发病率(例/千导管日)",
          fz: "相关尿路感染新发病例例次数",
          fzsz: "",
          fm: "同期住院患者导尿管累计使用天数",
          fmsz: "",
          sj: "",
          bz: "‰",
        },
        {
          zb: "指标十二",
          nr: "血液透折相关感染发生率",
          fz: "血液透析患者新发生相关感染的例次数",
          fzsz: "",
          fm: "同期血液透析总人数",
          fmsz: "",
          sj: "",
          bz: "%,指标中血液透析患者包括门诊和住院患者。本指标中相关感染是指血管导管相关血流感染、乙型病毒性肝炎、丙型病毒性肝炎、艾滋病和梅毒。各类型感染可分别统计",
        },
      ],
      tableData2: [],
      hospitalName: '',
      permission: 0
    };
  },
  components: {},
  created() {
    //旧
    // this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0];
    // this.hospitalNumber = this.loginUser.HospitalNumber;
    //新
    this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0]
    this.hospitalName = this.loginUser.HospitalName
    this.hospitalNumber = this.loginUser.HospitalNumber
    this.permission = this.loginUser.permission
    if (this.permission > 0) {
      this.hShow = true;
    } else this.hShow = false;
    this.tjny = [this.getCurrentYearMonth(), this.getCurrentYearMonth()]
  },
  mounted() {
    //旧
    // this.xAxisData = this.getBetweenMonth(
    //   this.searchForm.tjsj[0],
    //   this.searchForm.tjsj[1]
    // );
    // this.searchParams.yydm = this.hospitalNumber;
    // this.searchParams.kssj = this.searchForm.tjsj[0];
    // this.searchParams.jssj =
    //   this.searchForm.tjsj[1] +
    //   "-" +
    //   this.getLastDayOfMonth(
    //     this.searchForm.tjsj[0].split("-")[0],
    //     this.searchForm.tjsj[0].split("-")[1]
    //   );
    // this.getData();
    // this.initLineChart();
    //新
    this.getHospital()
    this.getAreaData()
    // if (this.hospitalNumber != "5100000000") {
    //   this.searchData()
    // }
  },
  methods: {
    //新
    exportAllData() {
      if (!this.isAllHsopital) {
        // 1. 准备导出数据
        const exportData = this.tableData.map(item => ({
          '指标': item.zb,
          '内容': item.nr,
          '分子': item.fz,
          '分子数值': item.fzsz,
          '分母': item.fm,
          '分母数值': item.fmsz,
          '结果数据': item.sj,
          '备注': item.bz
        }));

        // 2. 创建工作表
        const ws = XLSX.utils.json_to_sheet(exportData);

        // 3. 插入顶部标题(在 A1 单元格)
        const title = this.searchArea || this.searchHospitalName + '-感染监测数据分析结果-' + this.tjny[0] + '-' + this.tjny[1];
        XLSX.utils.sheet_add_aoa(ws, [[title]], { origin: 'A1' });

        // 4. 合并 A1:H1(共 8 列)
        ws['!merges'] = ws['!merges'] || [];
        ws['!merges'].push({
          s: { r: 0, c: 0 },  // 开始：第 0 行,第 0 列(A1)
          e: { r: 0, c: 7 }   // 结束：第 0 行,第 7 列(H1)
        });

        // 5. 调整数据从第 3 行开始(跳过标题和空行)
        // 注意：json_to_sheet 默认从第 2 行开始写表头,所以我们需要把表头也往下移
        XLSX.utils.sheet_add_json(ws, exportData, { origin: 'A3' });

        // 6. 删除原来的表头行(第 2 行)避免重复
        if (ws['A2']) delete ws['A2'];
        if (ws['B2']) delete ws['B2'];
        if (ws['C2']) delete ws['C2'];
        if (ws['D2']) delete ws['D2'];
        if (ws['E2']) delete ws['E2'];
        if (ws['F2']) delete ws['F2'];
        if (ws['G2']) delete ws['G2'];
        if (ws['H2']) delete ws['H2'];

        ws['!merges'].push({
          s: { r: 0, c: 0 }, // 开始单元格：A1 (第0行,第0列)
          e: { r: 1, c: 7 }  // 结束单元格：H2 (第1行,第7列)
        });

        // 7. 更新工作表范围(可选)
        ws['!ref'] = XLSX.utils.encode_range({
          s: { c: 0, r: 0 },
          e: { c: 7, r: exportData.length + 2 }  // +2：标题行 + 表头行
        });

        // 8. 创建工作簿并导出
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '感染监测数据分析结果');
        XLSX.writeFile(wb, this.searchArea || this.searchHospitalName + '-感染监测数据分析结果-' + this.tjny[0] + '-' + this.tjny[1] + '.xlsx');
      } else {
        // 1. 准备导出数据
        const exportData = this.tableData2.map(item => ({
          '备注': item.dataType,
          '市': item.name,
          '级别': item.HospitalLevel,
          '类型': item.hospitalProperty,
          '医院名称': item.HospitalName,
          '统计月份': item.tjny,
          '实际开放床位数': item.fz1,
          '同期感控专职人员数': item.fm1,
          '感控专职人员床位比': item.sj1,

          '医疗机构工作人员实际执行手卫生时机数': item.fz2,
          '同期应执行手卫生时机数': item.fm2,
          '医疗机构工作人员手卫生依从率': item.sj2,
          '医疗机构医生人员实际执行手卫生时机数': item.fz2_1,
          '同期医生人员应执行手卫生时机数': item.fm2_1,
          '医疗机构医生人员手卫生依从率': item.sj2_1,
          '医疗机构护士人员实际执行手卫生时机数': item.fz2_2,
          '同期护士人员应执行手卫生时机数': item.fm2_2,
          '医疗机构护士人员手卫生依从率': item.sj2_2,
          '医疗机构其他人员实际执行手卫生时机数': item.fz2_3,
          '同期其他人员应执行手卫生时机数': item.fm2_3,
          '医疗机构其他人员手卫生依从率': item.sj2_3,

          '医院感染新发病例例次数': item.fz3,
          '同期住院患者累计住院天数': item.fm3,
          '千日医院感染例次发病率(例/千住院日)': item.sj3,

          '新生儿医院感染新发病例例次数': item.fz4,
          '同期新生儿住院患者累计住院天数': item.fm4,
          '新生儿千日医院感染例次发病率(例/千住院日)': item.sj4,

          '特定多重耐药菌医院感染新发病例例次数': item.fz5,
          '同期住院患者累计住院天数0': item.fm5,
          '千日特定多重耐药菌医院感染例次发病率(例/千住院日)': item.sj5,
          '耐甲氧西林金黄色葡萄球菌(MRSA)医院感染新发病例例次数': item.fz5_1,
          '同期住院患者累计住院天数1': item.fm5_1,
          '耐甲氧西林金黄色葡萄球菌(MRSA)(例/千住院日)': item.sj5_1,
          '耐万古霉素屎肠球菌医院感染新发病例例次数': item.fz5_2,
          '同期住院患者累计住院天数2': item.fm5_2,
          '耐万古霉素屎肠球菌(例/千住院日)': item.sj5_2,
          // '耐万古霉素粪肠球菌医院感染新发病例例次数': item.fz5_3,
          // '同期住院患者累计住院天数3': item.fm5_3,
          // '耐万古霉素粪肠球菌(例/千住院日)': item.sj5_3,
          '耐碳青霉烯类肺炎克雷伯菌(CRKP)医院感染新发病例例次数': item.fz5_4,
          '同期住院患者累计住院天数4': item.fm5_4,
          '耐碳青霉烯类肺炎克雷伯菌(CRKP)(例/千住院日)': item.sj5_4,
          '耐碳青霉烯类大肠埃希菌(CREC)医院感染新发病例例次数': item.fz5_5,
          '同期住院患者累计住院天数5': item.fm5_5,
          '耐碳青霉烯类大肠埃希菌(CREC)(例/千住院日)': item.sj5_5,
          '耐碳青霉烯类铜绿假单胞菌(CRPA)医院感染新发病例例次数': item.fz5_6,
          '同期住院患者累计住院天数6': item.fm5_6,
          '耐碳青霉烯类铜绿假单胞菌(CRPA)(例/千住院日)': item.sj5_6,
          '耐碳青霉烯类鲍曼不动杆菌(CRAB)医院感染新发病例例次数': item.fz5_7,
          '同期住院患者累计住院天数7': item.fm5_7,
          '耐碳青霉烯类鲍曼不动杆菌(CRAB)(例/千住院日)': item.sj5_7,

          '联合使用重点抗菌药物治疗前病原学送检的住院患者人数': item.fz6,
          '同期联合使用重点抗菌药物治疗的住院患者总人数': item.fm6,
          '住院患者联合使用重点抗菌药物治疗前病原学送检率': item.sj6,

          '住院患者中预防性使用抗菌药物的Ⅰ类切口手术例次数': item.fz7,
          '同期住院患者Ⅰ类切口手术总例次数': item.fm7,
          '住院患者I类切口手术抗菌药物预防使用率': item.sj7,


          '住院患者Ⅰ类切口手术发生手术部位感染的例次数': item.fz8,
          '同期住院患者Ⅰ类切口手术总例次数0': item.fm8,
          '住院患者I类切口手术部位感染率': item.sj8,
          '同期I类切口手术(脑出血)发生手术部位感染的例次数': item.fz8_1,
          '同期I类切口手术(脑出血)例次数': item.fm8_1,
          'I类切口手术部位(脑出血)感染率': item.sj8_1,
          '同期I类切口手术(髋关节置换)发生手术部位感染的例次数': item.fz8_2,
          '同期I类切口手术(髋关节置换)例次数': item.fm8_2,
          'I类切口手术部位(髋关节置换)感染率': item.sj8_2,
          '同期I类切口手术(膝关节置换)发生手术部位感染的例次数': item.fz8_3,
          '同期I类切口手术(膝关节置换)例次数': item.fm8_3,
          'I类切口手术部位(膝关节置换)感染率': item.sj8_3,

          '相关血流感染新发病例例次数': item.fz9,
          '同期住院患者血管导管累计使用天数': item.fm9,
          '血管导管相关血流感染发病率(例/千导管日)': item.sj9,

          '相关肺炎新发病例例次数': item.fz10,
          '同期住院患者有创呼吸机累计使用天数': item.fm10,
          '呼吸机相关肺炎发病率(例/千导管日)': item.sj10,

          '相关尿路感染新发病例例次数': item.fz11,
          '同期住院患者导尿管累计使用天数': item.fm11,
          '导尿管相关尿路感染发病率(例/千导管日)': item.sj11,

          '血液透析患者新发生相关感染的例次数': item.fz12,
          '同期血液透析总人数': item.fm12,
          '血液透折相关感染发生率': item.sj12,
        }));

        // 2. 创建工作表(不带表头)
        const ws = XLSX.utils.json_to_sheet(exportData, { skipHeader: true });

        // 3. 插入文件名称行
        const fileName = '感染监测数据分析结果-' + this.tjny[0] + '-' + this.tjny[1];
        ws['A1'] = { v: fileName, t: 's' };
        ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 77 } }];

        // 4. 插入多级标题行
        const merges = [
          { s: { r: 1, c: 6 }, e: { r: 1, c: 8 } }, // 指标一
          { s: { r: 1, c: 9 }, e: { r: 1, c: 20 } }, // 指标二
          { s: { r: 1, c: 21 }, e: { r: 1, c: 23 } }, // 指标三
          { s: { r: 1, c: 24 }, e: { r: 1, c: 26 } }, // 指标四
          { s: { r: 1, c: 27 }, e: { r: 1, c: 47 } }, // 指标五
          { s: { r: 1, c: 48 }, e: { r: 1, c: 50 } }, // 指标六
          { s: { r: 1, c: 51 }, e: { r: 1, c: 53 } }, // 指标七
          { s: { r: 1, c: 54 }, e: { r: 1, c: 65 } }, // 指标八
          { s: { r: 1, c: 66 }, e: { r: 1, c: 68 } }, // 指标九
          { s: { r: 1, c: 69 }, e: { r: 1, c: 71 } }, // 指标十
          { s: { r: 1, c: 72 }, e: { r: 1, c: 74 } }, // 指标十一
          { s: { r: 1, c: 75 }, e: { r: 1, c: 77 } }, // 指标十二
        ];

        const titles = [
          '指标一', '指标二', '指标三', '指标四', '指标五', '指标六', '指标七', '指标八', '指标九', '指标十', '指标十一', '指标十二'
        ];

        merges.forEach((merge, index) => {
          ws['!merges'].push(merge);
          const cellRef = XLSX.utils.encode_cell({ r: 1, c: merge.s.c });
          ws[cellRef] = { v: titles[index], t: 's' };
        });

        // 5. 添加列标题行
        const headers = Object.keys(exportData[0]);
        headers.forEach((header, colIndex) => {
          const cellRef = XLSX.utils.encode_cell({ r: 2, c: colIndex });
          ws[cellRef] = { v: header, t: 's' };
        });

        // 6. 合并A2和A3单元格,并设置值为"统计月份"
        ws['!merges'].push({ s: { r: 1, c: 0 }, e: { r: 2, c: 0 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 0 })] = { v: '备注', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 1 }, e: { r: 2, c: 1 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 1 })] = { v: '市', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 2 }, e: { r: 2, c: 2 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 2 })] = { v: '级别', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 3 }, e: { r: 2, c: 3 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 3 })] = { v: '类型', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 4 }, e: { r: 2, c: 4 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 4 })] = { v: '医院名称', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 5 }, e: { r: 2, c: 5 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 5 })] = { v: '统计月份', t: 's' };

        // 7. 调整数据从第 4 行开始(跳过标题和空行)
        let row = 3; // 从第4行开始写入数据
        exportData.forEach(item => {
          Object.keys(item).forEach((key, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({ r: row, c: colIndex });
            ws[cellRef] = { v: item[key], t: typeof item[key] === 'number' ? 'n' : 's' }; // 根据数据类型选择 'n' 或 's'
          });
          row++;
        });

        // 8. 更新工作表范围(可选)
        ws['!ref'] = XLSX.utils.encode_range({
          s: { c: 0, r: 0 },
          e: { c: 77, r: row - 1 }  // 文件名称行 + 多级标题行 + 列标题行 + 数据行数
        });

        // 9. 创建工作簿并导出
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '感染监测数据分析结果');
        XLSX.writeFile(wb, '感染监测数据分析结果-' + this.tjny[0] + '-' + this.tjny[1] + '.xlsx');
      }
    },
    searchData() {
      if (this.permission > 0 && this.searchArea == '' && this.searchHospitalNumber == '') {
        this.$message.warning("请选择需要查询的区域")
        return
      }
      if (!this.tjny) {
        this.$message.warning("请选择需要查询的月份")
        return
      }
      for (let i = 0; i < this.hospitalData.length; i++) {
        if (this.hospitalData[i].HospitalNumber == this.searchHospitalNumber) {
          this.searchHospitalName = this.hospitalData[i].HospitalName
        }
      }
      if (this.permission < 1) {
        this.searchHospitalNumber = this.hospitalNumber
      } else {
        if (this.searchHospitalNumber == '') {
          this.searchHospitalNumber = this.permission.toString()
        }
      }
      if (this.searchArea == '') {
        this.isAllHsopital = false
        if (this.tjny[0] == this.tjny[1]) {
          this.isAllHsopital = false
        } else {
          this.isAllHsopital = true
        }
      } else {
        this.isAllHsopital = true
      }
      this.newload = true
      getCalculationIndexResults({
        yydm: this.searchHospitalNumber || this.hospitalNumber,
        kssj: this.tjny[0],
        jssj: this.tjny[1],
        area: this.searchArea.toString()
      }).then((res) => {
        this.newload = false
        if (!this.isAllHsopital) {
          if (res.data.length < 1) {
            this.tableData[0].fzsz = ''
            this.tableData[0].fmsz = ''
            this.tableData[0].sj = ''

            this.tableData[1].fzsz = ''
            this.tableData[1].fmsz = ''
            this.tableData[1].sj = ''

            this.tableData[2].fzsz = ''
            this.tableData[2].fmsz = ''
            this.tableData[2].sj = ''

            this.tableData[3].fzsz = ''
            this.tableData[3].fmsz = ''
            this.tableData[3].sj = ''

            this.tableData[4].fzsz = ''
            this.tableData[4].fmsz = ''
            this.tableData[4].sj = ''

            this.tableData[5].fzsz = ''
            this.tableData[5].fmsz = ''
            this.tableData[5].sj = ''

            this.tableData[6].fzsz = ''
            this.tableData[6].fmsz = ''
            this.tableData[6].sj = ''

            this.tableData[7].fzsz = ''
            this.tableData[7].fmsz = ''
            this.tableData[7].sj = ''

            this.tableData[8].fzsz = ''
            this.tableData[8].fmsz = ''
            this.tableData[8].sj = ''

            this.tableData[9].fzsz = ''
            this.tableData[9].fmsz = ''
            this.tableData[9].sj = ''

            // this.tableData[10].fzsz = ''
            // this.tableData[10].fmsz = ''
            // this.tableData[10].sj = ''

            this.tableData[10].fzsz = ''
            this.tableData[10].fmsz = ''
            this.tableData[10].sj = ''

            this.tableData[11].fzsz = ''
            this.tableData[11].fmsz = ''
            this.tableData[11].sj = ''

            this.tableData[12].fzsz = ''
            this.tableData[12].fmsz = ''
            this.tableData[12].sj = ''

            this.tableData[13].fzsz = ''
            this.tableData[13].fmsz = ''
            this.tableData[13].sj = ''

            this.tableData[14].fzsz = ''
            this.tableData[14].fmsz = ''
            this.tableData[14].sj = ''

            this.tableData[15].fzsz = ''
            this.tableData[15].fmsz = ''
            this.tableData[15].sj = ''

            this.tableData[16].fzsz = ''
            this.tableData[16].fmsz = ''
            this.tableData[16].sj = ''

            this.tableData[17].fzsz = ''
            this.tableData[17].fmsz = ''
            this.tableData[17].sj = ''

            this.tableData[18].fzsz = ''
            this.tableData[18].fmsz = ''
            this.tableData[18].sj = ''

            this.tableData[19].fzsz = ''
            this.tableData[19].fmsz = ''
            this.tableData[19].sj = ''

            this.tableData[20].fzsz = ''
            this.tableData[20].fmsz = ''
            this.tableData[20].sj = ''

            this.tableData[21].fzsz = ''
            this.tableData[21].fmsz = ''
            this.tableData[21].sj = ''

            this.tableData[22].fzsz = ''
            this.tableData[22].fmsz = ''
            this.tableData[22].sj = ''

            this.tableData[23].fzsz = ''
            this.tableData[23].fmsz = ''
            this.tableData[23].sj = ''
            this.$message.info("无数据")
          } else {
            this.tableData[0].fzsz = res.data[0].fz1
            this.tableData[0].fmsz = res.data[0].fm1
            this.tableData[0].sj = res.data[0].sj1

            this.tableData[1].fzsz = res.data[0].fz2
            this.tableData[1].fmsz = res.data[0].fm2
            this.tableData[1].sj = res.data[0].sj2

            this.tableData[2].fzsz = res.data[0].fz2_1
            this.tableData[2].fmsz = res.data[0].fm2_1
            this.tableData[2].sj = res.data[0].sj2_1

            this.tableData[3].fzsz = res.data[0].fz2_2
            this.tableData[3].fmsz = res.data[0].fm2_2
            this.tableData[3].sj = res.data[0].sj2_2

            this.tableData[4].fzsz = res.data[0].fz2_3
            this.tableData[4].fmsz = res.data[0].fm2_3
            this.tableData[4].sj = res.data[0].sj2_3

            this.tableData[5].fzsz = res.data[0].fz3
            this.tableData[5].fmsz = res.data[0].fm3
            this.tableData[5].sj = res.data[0].sj3

            this.tableData[6].fzsz = res.data[0].fz4
            this.tableData[6].fmsz = res.data[0].fm4
            this.tableData[6].sj = res.data[0].sj4

            this.tableData[7].fzsz = res.data[0].fz5
            this.tableData[7].fmsz = res.data[0].fm5
            this.tableData[7].sj = res.data[0].sj5

            this.tableData[8].fzsz = res.data[0].fz5_1
            this.tableData[8].fmsz = res.data[0].fm5_1
            this.tableData[8].sj = res.data[0].sj5_1

            this.tableData[9].fzsz = res.data[0].fz5_2
            this.tableData[9].fmsz = res.data[0].fm5_2
            this.tableData[9].sj = res.data[0].sj5_2

            // this.tableData[10].fzsz = res.data[0].fz5_3
            // this.tableData[10].fmsz = res.data[0].fm5_3
            // this.tableData[10].sj = res.data[0].fm5_3

            this.tableData[10].fzsz = res.data[0].fz5_4
            this.tableData[10].fmsz = res.data[0].fm5_4
            this.tableData[10].sj = res.data[0].sj5_4

            this.tableData[11].fzsz = res.data[0].fz5_5
            this.tableData[11].fmsz = res.data[0].fm5_5
            this.tableData[11].sj = res.data[0].sj5_5

            this.tableData[12].fzsz = res.data[0].fz5_6
            this.tableData[12].fmsz = res.data[0].fm5_6
            this.tableData[12].sj = res.data[0].sj5_6

            this.tableData[13].fzsz = res.data[0].fz5_7
            this.tableData[13].fmsz = res.data[0].fm5_7
            this.tableData[13].sj = res.data[0].sj5_7

            this.tableData[14].fzsz = res.data[0].fz6
            this.tableData[14].fmsz = res.data[0].fm6
            this.tableData[14].sj = res.data[0].sj6

            this.tableData[15].fzsz = res.data[0].fz7
            this.tableData[15].fmsz = res.data[0].fm7
            this.tableData[15].sj = res.data[0].sj7

            this.tableData[16].fzsz = res.data[0].fz8
            this.tableData[16].fmsz = res.data[0].fm8
            this.tableData[16].sj = res.data[0].sj8

            this.tableData[17].fzsz = res.data[0].fz8_1
            this.tableData[17].fmsz = res.data[0].fm8_1
            this.tableData[17].sj = res.data[0].sj8_1

            this.tableData[18].fzsz = res.data[0].fz8_2
            this.tableData[18].fmsz = res.data[0].fm8_2
            this.tableData[18].sj = res.data[0].sj8_2

            this.tableData[19].fzsz = res.data[0].fz8_3
            this.tableData[19].fmsz = res.data[0].fm8_3
            this.tableData[19].sj = res.data[0].sj8_3

            this.tableData[20].fzsz = res.data[0].fz9
            this.tableData[20].fmsz = res.data[0].fm9
            this.tableData[20].sj = res.data[0].sj9

            this.tableData[21].fzsz = res.data[0].fz10
            this.tableData[21].fmsz = res.data[0].fm10
            this.tableData[21].sj = res.data[0].sj10

            this.tableData[22].fzsz = res.data[0].fz11
            this.tableData[22].fmsz = res.data[0].fm11
            this.tableData[22].sj = res.data[0].sj11

            this.tableData[23].fzsz = res.data[0].fz12
            this.tableData[23].fmsz = res.data[0].fm12
            this.tableData[23].sj = res.data[0].sj12
          }
        } else {
          this.tableData2 = res.data
        }
      });
    },
    areaChange() {
      this.searchHospitalNumber = ''
    },
    hospitalChange() {
      this.searchArea = ''
    },
    getAreaData() {
      this.area = [];
      getAllArea().then((res) => {
        this.areaData = []
        if (this.permission == 1) {
          this.areaData.push({
            id: "all",
            label: "全部",
          });
          for (let i = 0; i < res.data2.length; i++) {
            this.areaData.push({
              id: res.data2[i].id,
              label: res.data2[i].name,
            });
          }
        } else if (this.permission == 2) {
          this.areaData.push({
            id: this.loginUser.Area.split(",")[1],
            label: "全部",
          });
          for (let i = 0; i < res.data3.length; i++) {
            if (res.data3[i].cityid == this.loginUser.Area.split(',')[1]) {
              this.areaData.push({
                id: res.data3[i].id,
                label: res.data3[i].name,
              });
            }
          }
        } else if (this.permission == 3) {
          this.areaData.push({
            id: this.loginUser.Area.split(",")[2],
            label: "全部",
          });
          for (let i = 0; i < res.data3.length; i++) {
            if (res.data3[i].id == this.loginUser.Area.split(',')[2]) {
              this.areaData.push({
                id: res.data3[i].id,
                label: res.data3[i].name,
              });
            }
          }
        }
      });
    },
    exportData() {
      if (!this.isAllHsopital) {
        // 1. 准备导出数据
        const exportData = this.tableData.map(item => ({
          '指标': item.zb,
          '内容': item.nr,
          '分子': item.fz,
          '分子数值': item.fzsz,
          '分母': item.fm,
          '分母数值': item.fmsz,
          '结果数据': item.sj,
          '备注': item.bz
        }));

        // 2. 创建工作表
        const ws = XLSX.utils.json_to_sheet(exportData);

        // 3. 插入顶部标题(在 A1 单元格)
        const title = '感染监测数据分析结果-' + this.hospitalName + '-' + this.tjny[0] + '-' + this.tjny[1];
        XLSX.utils.sheet_add_aoa(ws, [[title]], { origin: 'A1' });

        // 4. 合并 A1:H1(共 8 列)
        ws['!merges'] = ws['!merges'] || [];
        ws['!merges'].push({
          s: { r: 0, c: 0 },  // 开始：第 0 行,第 0 列(A1)
          e: { r: 0, c: 7 }   // 结束：第 0 行,第 7 列(H1)
        });

        // 5. 调整数据从第 3 行开始(跳过标题和空行)
        // 注意：json_to_sheet 默认从第 2 行开始写表头,所以我们需要把表头也往下移
        XLSX.utils.sheet_add_json(ws, exportData, { origin: 'A3' });

        // 6. 删除原来的表头行(第 2 行)避免重复
        if (ws['A2']) delete ws['A2'];
        if (ws['B2']) delete ws['B2'];
        if (ws['C2']) delete ws['C2'];
        if (ws['D2']) delete ws['D2'];
        if (ws['E2']) delete ws['E2'];
        if (ws['F2']) delete ws['F2'];
        if (ws['G2']) delete ws['G2'];
        if (ws['H2']) delete ws['H2'];

        ws['!merges'].push({
          s: { r: 0, c: 0 }, // 开始单元格：A1 (第0行,第0列)
          e: { r: 1, c: 7 }  // 结束单元格：H2 (第1行,第7列)
        });

        // 7. 更新工作表范围(可选)
        ws['!ref'] = XLSX.utils.encode_range({
          s: { c: 0, r: 0 },
          e: { c: 7, r: exportData.length + 2 }  // +2：标题行 + 表头行
        });

        // 8. 创建工作簿并导出
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '感染监测数据分析结果');
        XLSX.writeFile(wb, '感染监测数据分析结果-' + this.hospitalName + '-' + this.tjny[0] + '-' + this.tjny[1] + '.xlsx');
      } else {
        // 1. 准备导出数据
        const exportData = this.tableData2.map(item => ({
          '备注': item.dataType,
          '市': item.name,
          '级别': item.HospitalLevel,
          '类型': item.hospitalProperty,
          '医院名称': item.HospitalName,
          '统计月份': item.tjny,
          '实际开放床位数': item.fz1,
          '同期感控专职人员数': item.fm1,
          '感控专职人员床位比': item.sj1,

          '医疗机构工作人员实际执行手卫生时机数': item.fz2,
          '同期应执行手卫生时机数': item.fm2,
          '医疗机构工作人员手卫生依从率': item.sj2,
          '医疗机构医生人员实际执行手卫生时机数': item.fz2_1,
          '同期医生人员应执行手卫生时机数': item.fm2_1,
          '医疗机构医生人员手卫生依从率': item.sj2_1,
          '医疗机构护士人员实际执行手卫生时机数': item.fz2_2,
          '同期护士人员应执行手卫生时机数': item.fm2_2,
          '医疗机构护士人员手卫生依从率': item.sj2_2,
          '医疗机构其他人员实际执行手卫生时机数': item.fz2_3,
          '同期其他人员应执行手卫生时机数': item.fm2_3,
          '医疗机构其他人员手卫生依从率': item.sj2_3,

          '医院感染新发病例例次数': item.fz3,
          '同期住院患者累计住院天数': item.fm3,
          '千日医院感染例次发病率(例/千住院日)': item.sj3,

          '新生儿医院感染新发病例例次数': item.fz4,
          '同期新生儿住院患者累计住院天数': item.fm4,
          '新生儿千日医院感染例次发病率(例/千住院日)': item.sj4,

          '特定多重耐药菌医院感染新发病例例次数': item.fz5,
          '同期住院患者累计住院天数0': item.fm5,
          '千日特定多重耐药菌医院感染例次发病率(例/千住院日)': item.sj5,
          '耐甲氧西林金黄色葡萄球菌(MRSA)医院感染新发病例例次数': item.fz5_1,
          '同期住院患者累计住院天数1': item.fm5_1,
          '耐甲氧西林金黄色葡萄球菌(MRSA)(例/千住院日)': item.sj5_1,
          '耐万古霉素屎肠球菌医院感染新发病例例次数': item.fz5_2,
          '同期住院患者累计住院天数2': item.fm5_2,
          '耐万古霉素屎肠球菌(例/千住院日)': item.sj5_2,
          // '耐万古霉素粪肠球菌医院感染新发病例例次数': item.fz5_3,
          // '同期住院患者累计住院天数3': item.fm5_3,
          // '耐万古霉素粪肠球菌(例/千住院日)': item.sj5_3,
          '耐碳青霉烯类肺炎克雷伯菌(CRKP)医院感染新发病例例次数': item.fz5_4,
          '同期住院患者累计住院天数4': item.fm5_4,
          '耐碳青霉烯类肺炎克雷伯菌(CRKP)(例/千住院日)': item.sj5_4,
          '耐碳青霉烯类大肠埃希菌(CREC)医院感染新发病例例次数': item.fz5_5,
          '同期住院患者累计住院天数5': item.fm5_5,
          '耐碳青霉烯类大肠埃希菌(CREC)(例/千住院日)': item.sj5_5,
          '耐碳青霉烯类铜绿假单胞菌(CRPA)医院感染新发病例例次数': item.fz5_6,
          '同期住院患者累计住院天数6': item.fm5_6,
          '耐碳青霉烯类铜绿假单胞菌(CRPA)(例/千住院日)': item.sj5_6,
          '耐碳青霉烯类鲍曼不动杆菌(CRAB)医院感染新发病例例次数': item.fz5_7,
          '同期住院患者累计住院天数7': item.fm5_7,
          '耐碳青霉烯类鲍曼不动杆菌(CRAB)(例/千住院日)': item.sj5_7,

          '联合使用重点抗菌药物治疗前病原学送检的住院患者人数': item.fz6,
          '同期联合使用重点抗菌药物治疗的住院患者总人数': item.fm6,
          '住院患者联合使用重点抗菌药物治疗前病原学送检率': item.sj6,

          '住院患者中预防性使用抗菌药物的Ⅰ类切口手术例次数': item.fz7,
          '同期住院患者Ⅰ类切口手术总例次数': item.fm7,
          '住院患者I类切口手术抗菌药物预防使用率': item.sj7,


          '住院患者Ⅰ类切口手术发生手术部位感染的例次数': item.fz8,
          '同期住院患者Ⅰ类切口手术总例次数0': item.fm8,
          '住院患者I类切口手术部位感染率': item.sj8,
          '同期I类切口手术(脑出血)发生手术部位感染的例次数': item.fz8_1,
          '同期I类切口手术(脑出血)例次数': item.fm8_1,
          'I类切口手术部位(脑出血)感染率': item.sj8_1,
          '同期I类切口手术(髋关节置换)发生手术部位感染的例次数': item.fz8_2,
          '同期I类切口手术(髋关节置换)例次数': item.fm8_2,
          'I类切口手术部位(髋关节置换)感染率': item.sj8_2,
          '同期I类切口手术(膝关节置换)发生手术部位感染的例次数': item.fz8_3,
          '同期I类切口手术(膝关节置换)例次数': item.fm8_3,
          'I类切口手术部位(膝关节置换)感染率': item.sj8_3,

          '相关血流感染新发病例例次数': item.fz9,
          '同期住院患者血管导管累计使用天数': item.fm9,
          '血管导管相关血流感染发病率(例/千导管日)': item.sj9,

          '相关肺炎新发病例例次数': item.fz10,
          '同期住院患者有创呼吸机累计使用天数': item.fm10,
          '呼吸机相关肺炎发病率(例/千导管日)': item.sj10,

          '相关尿路感染新发病例例次数': item.fz11,
          '同期住院患者导尿管累计使用天数': item.fm11,
          '导尿管相关尿路感染发病率(例/千导管日)': item.sj11,

          '血液透析患者新发生相关感染的例次数': item.fz12,
          '同期血液透析总人数': item.fm12,
          '血液透折相关感染发生率': item.sj12,
        }));

        // 2. 创建工作表(不带表头)
        const ws = XLSX.utils.json_to_sheet(exportData, { skipHeader: true });

        // 3. 插入文件名称行
        const fileName = '感染监测数据分析结果-' + this.tjny[0] + '-' + this.tjny[1];
        ws['A1'] = { v: fileName, t: 's' };
        ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 77 } }];

        // 4. 插入多级标题行
        const merges = [
          { s: { r: 1, c: 6 }, e: { r: 1, c: 8 } }, // 指标一
          { s: { r: 1, c: 9 }, e: { r: 1, c: 20 } }, // 指标二
          { s: { r: 1, c: 21 }, e: { r: 1, c: 23 } }, // 指标三
          { s: { r: 1, c: 24 }, e: { r: 1, c: 26 } }, // 指标四
          { s: { r: 1, c: 27 }, e: { r: 1, c: 47 } }, // 指标五
          { s: { r: 1, c: 48 }, e: { r: 1, c: 50 } }, // 指标六
          { s: { r: 1, c: 51 }, e: { r: 1, c: 53 } }, // 指标七
          { s: { r: 1, c: 54 }, e: { r: 1, c: 65 } }, // 指标八
          { s: { r: 1, c: 66 }, e: { r: 1, c: 68 } }, // 指标九
          { s: { r: 1, c: 69 }, e: { r: 1, c: 71 } }, // 指标十
          { s: { r: 1, c: 72 }, e: { r: 1, c: 74 } }, // 指标十一
          { s: { r: 1, c: 75 }, e: { r: 1, c: 77 } }, // 指标十二
        ];

        const titles = [
          '指标一', '指标二', '指标三', '指标四', '指标五', '指标六', '指标七', '指标八', '指标九', '指标十', '指标十一', '指标十二'
        ];

        merges.forEach((merge, index) => {
          ws['!merges'].push(merge);
          const cellRef = XLSX.utils.encode_cell({ r: 1, c: merge.s.c });
          ws[cellRef] = { v: titles[index], t: 's' };
        });

        // 5. 添加列标题行
        const headers = Object.keys(exportData[0]);
        headers.forEach((header, colIndex) => {
          const cellRef = XLSX.utils.encode_cell({ r: 2, c: colIndex });
          ws[cellRef] = { v: header, t: 's' };
        });

        // 6. 合并A2和A3单元格,并设置值为"统计月份"
        ws['!merges'].push({ s: { r: 1, c: 0 }, e: { r: 2, c: 0 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 0 })] = { v: '备注', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 1 }, e: { r: 2, c: 1 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 1 })] = { v: '市', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 2 }, e: { r: 2, c: 2 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 2 })] = { v: '级别', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 3 }, e: { r: 2, c: 3 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 3 })] = { v: '类型', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 4 }, e: { r: 2, c: 4 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 4 })] = { v: '医院名称', t: 's' };

        ws['!merges'].push({ s: { r: 1, c: 5 }, e: { r: 2, c: 5 } });
        ws[XLSX.utils.encode_cell({ r: 1, c: 5 })] = { v: '统计月份', t: 's' };

        // 7. 调整数据从第 4 行开始(跳过标题和空行)
        let row = 3; // 从第4行开始写入数据
        exportData.forEach(item => {
          Object.keys(item).forEach((key, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({ r: row, c: colIndex });
            ws[cellRef] = { v: item[key], t: typeof item[key] === 'number' ? 'n' : 's' }; // 根据数据类型选择 'n' 或 's'
          });
          row++;
        });

        // 8. 更新工作表范围(可选)
        ws['!ref'] = XLSX.utils.encode_range({
          s: { c: 0, r: 0 },
          e: { c: 77, r: row - 1 }  // 文件名称行 + 多级标题行 + 列标题行 + 数据行数
        });

        // 9. 创建工作簿并导出
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '感染监测数据分析结果');
        XLSX.writeFile(wb, '感染监测数据分析结果-' + this.tjny[0] + '-' + this.tjny[1] + '.xlsx');
      }
    },
    getCurrentYearMonth() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, "0")
      return `${year}-${month}`
    },
    //旧
    getHospital() {
      getHospital({ hospitalName: "" }).then((res) => {
        this.hospitalData = []
        for (let i = 0; i < res.data.length; i++) {
          if (this.permission == 1) {
            this.hospitalData = res.data;
          } else if (this.permission == 2) {
            if (res.data[i].Area.split(',')[1] == this.loginUser.Area.split(',')[1]) {
              this.hospitalData.push(res.data[i])
            }
          } else if (this.permission == 3) {
            if (res.data[i].Area.split(',')[2] == this.loginUser.Area.split(',')[2]) {
              this.hospitalData.push(res.data[i])
            }
          }
        }
      });
    },
    tjlxClick(item) {
      switch (item) {
        case "本月":
          this.searchForm.tjsj = [
            this.getCurrentDateYYYYMM(),
            this.getCurrentDateYYYYMM(),
          ];
          break;
        case "本季":
          this.searchForm.tjsj = [
            this.getCurrentSeason().start,
            this.getCurrentSeason().end,
          ];
          break;
        case "上半年":
          this.searchForm.tjsj = [
            this.calculateHalfYearDates().start,
            this.calculateHalfYearDates().end,
          ];
          break;
        case "下半年":
          this.searchForm.tjsj = [
            this.calculateHalfYearDates2().start,
            this.calculateHalfYearDates2().end,
          ];
          break;
        case "本年":
          this.searchForm.tjsj = [
            this.calculateHalfYearDates3().start,
            this.calculateHalfYearDates3().end,
          ];
          break;
      }
    },
    handleChange(value) {
      if (value && value.length === 2) {
        if (value[0] !== value[1]) {
          this.searchForm.tjsj[0] = value[0];
          this.searchForm.tjsj[1] = value[0];
        }
      }
    },
    zbmcClick(row) {
      this.loading2 = true;
      this.searchParams.area = this.searchArea.toString();
      this.clickName = row.zbmc;
      switch (row.zbmc) {
        case "感控专职人员床位比":
          this.lineData = [];
          this.tjChildData = [];
          this.loading2 = false;
          break;
        case "医疗机构工作人员手卫生依从率":
          getInfectionIncidence(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getInfectionIncidence2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "千日医院感染例次发病率":
          getIncidenceRate(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getIncidenceRate2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "新生儿千日医院感染例次发病率":
          getInfectionDetection(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getInfectionDetection2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "千日特定多重耐药菌医院感染例次发病率":
          getCaseIncidence(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getCaseIncidence2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "住院患者联合使用重点抗菌药物治疗前病原学送检率":
          getDetectionRate(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getDetectionRate2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "住院患者I类切口手术抗菌药物预防使用率":
          getDrawingRate(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getDrawingRate2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "住院患者I类切口手术部位感染率":
          getAntibioticsInpatients(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getAntibioticsInpatients2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "中心静脉导管相关血流感染发病率":
          getDeliveryRate(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getDeliveryRate2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "呼吸机相关肺炎发病率":
          getInfectionRate(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getInfectionRate2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "导尿管相关尿路感染发病率":
          getUtilizationRate(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getUtilizationRate2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        case "血液透折相关感染发生率":
          getIncidenceIntravascular(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.lineData = res.data;
            } else {
              this.lineData = [];
            }
          });
          getIncidenceIntravascular2(this.searchParams).then((res) => {
            this.loading2 = false;
            if (res.data.length > 0) {
              this.tjChildData = res.data;
            } else {
              this.tjChildData = [];
            }
          });
          break;
        // case "呼吸机相关肺炎发病率":
        //   getIncidenceUrinary(this.searchParams).then((res) => {
        //     this.lineData = res.data;
        //   });
        //   getIncidenceUrinary2(this.searchParams).then((res) => {
        //     this.tjChildData = res.data;
        //   });
        //   break;
        // case "导尿管相关泌尿道感染发病率":
        //   getIncidenceVentilator(this.searchParams).then((res) => {
        //     this.lineData = res.data;
        //   });
        //   getIncidenceVentilator2(this.searchParams).then((res) => {
        //     this.tjChildData = res.data;
        //   });
        //   break;
      }
      let _that = this;
      setTimeout(() => {
        if (_that.lineData.length !== _that.xAxisData.length) {
          for (let i = 0; i < _that.xAxisData.length - 1; i++) {
            _that.lineData.push(0);
          }
        }
        _that.initLineChart();
      }, 1000);
    },
    onSubmit() {
      this.xAxisData = this.getBetweenMonth(
        this.searchForm.tjsj[0],
        this.searchForm.tjsj[1]
      );
      this.searchParams.yydm = this.hospitalNumber;
      if (this.searchHospitalNumber != "") {
        this.searchParams.yydm = this.searchHospitalNumber;
      }
      this.searchParams.kssj = this.searchForm.tjsj[0];
      this.searchParams.jssj =
        this.searchForm.tjsj[1] +
        "-" +
        this.getLastDayOfMonth(
          this.searchForm.tjsj[1].split("-")[0],
          this.searchForm.tjsj[1].split("-")[1]
        );
      this.getData();
      this.initLineChart();
    },
    getLastDayOfMonth(year, month) {
      const date = new Date(year, month, 1); // 设置日期为当月第一天
      date.setMonth(date.getMonth()); // 月份加1变为下一个月
      date.setDate(0); // 日期设置为0，自动变为上个月的最后一天
      return date.getDate();
    },
    getData() {
      this.loading = true;
      //getStatisticalAnalysis(this.searchParams).then((res) => {
      this.searchParams.area = this.searchArea.toString();
      computeTwelveIndicators1(this.searchParams).then((res) => {
        this.lineData = [];
        this.tjChildData = [];
        if (res.data1.length > 0) {
          this.tjData[0].zhi =
            res.data1[0].personNum + ":" + res.data1[0].hospitalNumberOfBed ||
            0;
          this.tjData[0].lcs = res.data1[0].personNum || 0;
        } else {
          this.tjData[0].zhi = 0;
          this.tjData[0].lcs = 0;
        }
        if (res.data2.length > 0) {
          this.tjData[1].zhi = res.data2[0].content || 0;
          this.tjData[1].lcs = res.data2[0].num || 0;
        } else {
          this.tjData[1].zhi = 0;
          this.tjData[1].lcs = 0;
        }
        if (res.data3.length > 0) {
          this.tjData[2].zhi = res.data3[0].content || 0;
          this.tjData[2].lcs = res.data3[0].num || 0;
        } else {
          this.tjData[2].zhi = 0;
          this.tjData[2].lcs = 0;
        }
        if (res.data4.length > 0) {
          this.tjData[3].zhi = res.data4[0].content || 0;
          this.tjData[3].lcs = res.data4[0].num || 0;
        } else {
          this.tjData[3].zhi = 0;
          this.tjData[3].lcs = 0;
        }

        computeTwelveIndicators2(this.searchParams).then((res) => {
          this.lineData = [];
          this.tjChildData = [];
          if (res.data5.length > 0) {
            this.tjData[4].zhi = res.data5[0].content || 0;
            this.tjData[4].lcs = res.data5[0].num || 0;
          } else {
            this.tjData[4].zhi = 0;
            this.tjData[4].lcs = 0;
          }
          if (res.data6.length > 0) {
            this.tjData[5].zhi = res.data6[0].content || 0;
            this.tjData[5].lcs = res.data6[0].num || 0;
          } else {
            this.tjData[5].zhi = 0;
            this.tjData[5].lcs = 0;
          }
          if (res.data7.length > 0) {
            this.tjData[6].zhi = res.data7[0].content || 0;
            this.tjData[6].lcs = res.data7[0].num || 0;
          } else {
            this.tjData[6].zhi = 0;
            this.tjData[6].lcs = 0;
          }
          if (res.data8.length > 0) {
            this.tjData[7].zhi = res.data8[0].content || 0;
            this.tjData[7].lcs = res.data8[0].num || 0;
          } else {
            this.tjData[7].zhi = 0;
            this.tjData[7].lcs = 0;
          }

          computeTwelveIndicators3(this.searchParams).then((res) => {
            this.loading = false;
            this.lineData = [];
            this.tjChildData = [];
            if (res.data9.length > 0) {
              this.tjData[8].zhi = res.data9[0].content || 0;
              this.tjData[8].lcs = res.data9[0].num || 0;
            } else {
              this.tjData[8].zhi = 0;
              this.tjData[8].lcs = 0;
            }
            if (res.data10.length > 0) {
              this.tjData[9].zhi = res.data10[0].content || 0;
              this.tjData[9].lcs = res.data10[0].num || 0;
            } else {
              this.tjData[9].zhi = 0;
              this.tjData[9].lcs = 0;
            }
            if (res.data11.length > 0) {
              this.tjData[10].zhi = res.data11[0].content || 0;
              this.tjData[10].lcs = res.data11[0].num || 0;
            } else {
              this.tjData[10].zhi = 0;
              this.tjData[10].lcs = 0;
            }
            if (res.data12.length > 0) {
              this.tjData[11].zhi = res.data12[0].content || 0;
              this.tjData[11].lcs = res.data12[0].num || 0;
            } else {
              this.tjData[11].zhi = 0;
              this.tjData[11].lcs = 0;
            }
          });
        });
      });
    },
    getCurrentDateYYYYMM() {
      const now = new Date();
      const year = now.getFullYear();
      let month = now.getMonth() + 1;
      month = month.toString().padStart(2, "0");
      return `${year}-${month}`;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份需要+1，因为是从0开始的
      const day = date.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    },
    getCurrentSeason() {
      const now = new Date();
      let start, end;
      const month = now.getMonth(); // 0-11
      const year = now.getFullYear();

      // 判断当前季度
      const quarter = Math.floor(month / 3) + 1;

      // 计算季度开始和结束日
      if (quarter === 1) {
        start = new Date(year, 1, 1); // 1月1日
        end = new Date(year, 2, 31); // 3月31日
      } else if (quarter === 2) {
        start = new Date(year, 4, 1); // 4月1日
        end = new Date(year, 5, 30); // 6月30日
      } else if (quarter === 3) {
        start = new Date(year, 7, 1); // 7月1日
        end = new Date(year, 8, 31); // 9月31日
      } else if (quarter === 4) {
        start = new Date(year, 10, 1); // 10月1日
        end = new Date(year, 11, 31); // 12月31日
      }

      return {
        start: start.toISOString().substring(0, 7),
        end: end.toISOString().substring(0, 7),
      };
    },
    calculateHalfYearDates() {
      const now = new Date();
      const start = new Date(now.getFullYear(), 0, 1); // 本年的1月1号
      const end = new Date(now.getFullYear(), 5, 1); // 7月1号，作为本年上半年的结束
      let startOfSemester, endOfSemester;
      // 格式化日期为YYYY-MM-DD
      startOfSemester = this.formatDate(start);
      endOfSemester = this.formatDate(end);
      return {
        start: startOfSemester.substring(0, 7),
        end: endOfSemester.substring(0, 7),
      };
    },
    calculateHalfYearDates2() {
      const now = new Date();
      const start = new Date(now.getFullYear(), 6, 1); // 本年的1月1号
      const end = new Date(now.getFullYear(), 11, 1); // 7月1号，作为本年上半年的结束
      let startOfSemester, endOfSemester;
      // 格式化日期为YYYY-MM-DD
      startOfSemester = this.formatDate(start);
      endOfSemester = this.formatDate(end);
      return {
        start: startOfSemester.substring(0, 7),
        end: endOfSemester.substring(0, 7),
      };
    },
    calculateHalfYearDates3() {
      const now = new Date();
      const start = new Date(now.getFullYear(), 0, 1); // 本年的1月1号
      const end = new Date(now.getFullYear(), 11, 1); // 7月1号，作为本年上半年的结束
      let startOfSemester, endOfSemester;
      // 格式化日期为YYYY-MM-DD
      startOfSemester = this.formatDate(start);
      endOfSemester = this.formatDate(end);
      return {
        start: startOfSemester.substring(0, 7),
        end: endOfSemester.substring(0, 7),
      };
    },
    getBetweenMonth(startTime, endTime) {
      if (typeof startTime === "string") {
        const reg = /^\d{4}-(0?[1-9]|1[0-2])$/g;
        if (!reg.test(startTime)) throw `开始时间：${startTime}时间格式错误`;
      }
      if (typeof endTime === "string") {
        const reg = /^\d{4}-(0?[1-9]|1[0-2])$/g;
        if (!reg.test(endTime)) throw `结束时间：${endTime}时间格式错误`;
      }
      let start = new Date(startTime);
      let end = new Date(endTime);
      const resultTime = [];
      while (start <= end) {
        let getMonth = start.getMonth() + 1;
        let getYear = start.getFullYear();
        let setTime =
          `${getYear}-` + (getMonth >= 10 ? `${getMonth}` : `0${getMonth}`);

        resultTime.push(setTime);
        start = new Date(start.setFullYear(getYear, getMonth));
      }
      return resultTime;
    },
    initLineChart() {
      const chartDom = this.$refs.lineChart;
      const myChart = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [this.clickName],
        },
        xAxis: {
          type: "category",
          data: this.xAxisData,
        },
        yAxis: {
          // name: "%",
          type: "value",
        },
        series: [
          {
            name: this.clickName,
            data: this.lineData,
            type: "line",
            itemStyle: {
              color: "#2EC7C9",
            },
            lineStyle: {
              color: "#2EC7C9",
            },
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.search {
  margin-top: 20px;
  width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/views/machine/MachineAisle.vue